import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-x-4 justify-between items-center mb-16" }
const _hoisted_2 = { class: "mb-3 text-gray-700 font-semibold" }
const _hoisted_3 = { class: "flex flex-row gap-3" }
const _hoisted_4 = ["label", "name", "value", "onInput", "onUpdate:modelValue", "id"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-gray-700 font-semibold mb-8" }
const _hoisted_8 = { class: "table-fixed min-w-full w-full border-spacing-4" }
const _hoisted_9 = { class: "text text-success" }
const _hoisted_10 = { class: "columns" }
const _hoisted_11 = { class: "text-left text-gray-700 text-sm font-medium py-2 pr-2" }
const _hoisted_12 = { class: "text-left text-gray-700 text-sm font-medium p-2" }
const _hoisted_13 = { class: "text-left text-gray-700 text-sm font-medium p-2" }
const _hoisted_14 = { class: "text-left text-gray-700 text-sm font-medium p-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "text-left text-gray-700 text-sm font-medium py-2 pl-2 w-[100px]" }, null, -1)
const _hoisted_16 = { class: "py-2 pr-2 w-full flex" }
const _hoisted_17 = {
  key: 0,
  class: "relative"
}
const _hoisted_18 = { class: "mr-1 z-50 top-2 right-0 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6" }
const _hoisted_19 = { class: "flex-grow flex items-center" }
const _hoisted_20 = { class: "text-gray-700 border border-gray-300 bg-white font-semibold px-5 py-2.5 mr-2 rounded-lg" }
const _hoisted_21 = { class: "text-gray-700 border border-gray-300 bg-white font-semibold px-5 py-2.5 rounded-lg" }
const _hoisted_22 = { class: "p-2 w-full" }
const _hoisted_23 = { class: "flex w-full" }
const _hoisted_24 = {
  key: 0,
  class: "relative"
}
const _hoisted_25 = { class: "mr-1 z-50 top-2 right-0 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6" }
const _hoisted_26 = { class: "p-2" }
const _hoisted_27 = { class: "p-2" }
const _hoisted_28 = { class: "py-2 pl-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mr-1 z-50 top-0 right-0 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6 hover:cursor-pointer" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "py-2 pr-2 w-full flex relative" }
const _hoisted_33 = { class: "relative z-50 top-2 mr-1 h-6 w-6 [&>svg]:stroke-current [&>svg]:h-6 [&>svg]:w-6" }
const _hoisted_34 = { class: "p-2" }
const _hoisted_35 = { class: "p-2" }
const _hoisted_36 = { class: "p-2" }
const _hoisted_37 = { class: "py-2 pl-2" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "flex items-center gap-x-3" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_42 = { class: "flex w-full justify-end mt-5" }
const _hoisted_43 = {
  disabled: "",
  class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap disabled:opacity-50"
}
const _hoisted_44 = {
  key: 0,
  class: "inline-block me-2",
  role: "status"
}
const _hoisted_45 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_46 = { class: "mt-5 text-center" }
const _hoisted_47 = { class: "text-lg font-semibold mb-1" }
const _hoisted_48 = { class: "text-center" }
const _hoisted_49 = { class: "text-sm text-gray-600 mb-8" }
const _hoisted_50 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_51 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_52 = { class: "mt-5 text-center" }
const _hoisted_53 = { class: "text-lg font-semibold mb-1" }
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = { class: "text-sm text-gray-600 mb-8" }

import { ref, computed, onBeforeMount, watch, onMounted } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useLearnerStore } from "@/stores/learnerStore";
import i18n from "@/plugins/i18n";

import {
  TrashIcon,
  XMarkIcon,
  InformationCircleIcon,
} from "@heroicons/vue/24/outline";

import { ClassGroup } from "@/interfaces/class-group.interface";
import { unionBy } from "lodash";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { CheckCircleIcon } from "@heroicons/vue/20/solid";

import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n'

interface SubjectDisplay {
  id: string;
  name: string;
  show: boolean;
}

interface NewClassGroup {
  tempId: string;
  name: string;
  teacher: string;
  subject: string;
  gradeLevel: number;
  preferredLanguage: string;
  defaultStudentSettings: object;
}

interface NewTeacherAssignment {
  newTeacher: string;
  oldTeacher: string;
  classGroup: string;
}

interface ClassToDelete {
  teacher: string;
  classGroup: string;
}

// variables

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminSchoolDetailsComponent',
  props: {
  gradeLevel: {
    type: Number,
    required: true,
  },
  classes: {
    type: Array,
    default: () => [],
  },
  learners: {
    type: Object,
  },
  hasClasses: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();

function notifySuccessSchoolAdmin() {
  showToast({
    text: t('admin_screens.grades_and_classes_screen.update_success'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}

// interfaces
const errorMessage = ref("");
const showModal = ref(false);

// stores
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();

// props


// Method to get learner count based on class name and subject ID
const getLearnerCount = (className: string, subjectId: string) => {
  return props.learners.filter((learner: any) => {
    // Check if the learner is in the specified class and subject
    return learner.classes.some((classItem: any) => {
      return (
        classItem.name === className && classItem.subject._id === subjectId
      );
    });
  }).length;
};

// refs
const subjectDisplay = ref<SubjectDisplay[]>([]);
const newClasses = ref<NewClassGroup[]>([] as NewClassGroup[]);
const classesToDelete = ref<ClassToDelete[]>([] as ClassToDelete[]);
const newTeacherAssignments = ref<NewTeacherAssignment[]>(
  [] as NewTeacherAssignment[]
);
const updatedLanguagesOfLearning = ref<[]>([] as any);
const updatedDefaultStudentSettings = ref<[]>([] as any);

const showModalTwo = ref(false);
const loading = ref(false);
const updateSuccess = ref(false);

const closeModals = () => {
  showModalTwo.value = false;
};

const closeSuccess = () => {
  updateSuccess.value = false;
};

const isClassGroupMarkedForDeletion = computed(
  () => (classItemId: string, adminId: string) => {
    return classesToDelete.value.some((classToDelete) => {
      return (
        classToDelete.classGroup === classItemId &&
        classToDelete.teacher === adminId
      );
    });
  }
);

const isClassGroupMarkedForTeacherReassignment = computed(
  () => (classItemId: string) => {
    return newTeacherAssignments.value.some((teacherAssignment) => {
      return teacherAssignment.classGroup === classItemId;
    });
  }
);

const classesByGrade = computed(() =>
  schoolStore.currentSchoolStructure?.classGroups.filter((classGroup) => {
    return classGroup.gradeLevel === props.gradeLevel;
  })
);

const classGroupBySubject = computed(() => (subjectId: string) => {
  return classesByGrade.value
    ?.filter((classGroup: any) => {
      return classGroup.subject == subjectId;
    })
    .map((classGroup: any) => {
      const learnersInClass = learnerStore.getSchoolLearners.filter((learner) => {
        return (
          Array.isArray(learner.classes) &&
          learner.classes.some(
            (learnerClass: any) => learnerClass.subject._id === classGroup._id
          )
        );
      }).length;

      return {
        _id: classGroup._id,
        code: classGroup.code,
        name: classGroup.name,
        learners: learnersInClass,
        school: classGroup.school,
        subject: classGroup.subject,
        gradeLevel: classGroup.gradeLevel,
        preferredLanguage: classGroup.preferredLanguage,
        assignedTeacher:
          classGroup.admins.length > 0 ? classGroup.admins[0] : null,
      };
    });
});

// Function to check if a subject has classes
const hasClassesForSubject = (subjectId: any) => {
  const classes = classGroupBySubject.value(subjectId);
  return classes && classes.length > 0;
};

/**
 * Update the subjects display matrix when a subject is selected
 * @param subjectId
 */
onBeforeMount(() => {
  subjectDisplay.value = subjectStore.subjects.map((subject) => {
    return {
      id: subject.id,
      name: subject.name,
      show: false,
    };
  });
});

onMounted(() => {
  if (props.hasClasses) {
    subjectDisplay.value.forEach((subject) => {
      // Check if subject has classes
      hasClassesForSubject(subject.id)
        ? (subject.show = true)
        : (subject.show = false);
    });
  }
});

watch(
  () => props.hasClasses,
  (newValue) => {
    if (newValue) {
      subjectDisplay.value.forEach((subject) => {
        hasClassesForSubject(subject.id)
          ? (subject.show = true)
          : (subject.show = false);
      });
    }
  }
);

const updateSubjects = (subjectId: string) => {
  subjectDisplay.value = subjectDisplay.value.map((subject) => {
    if (subject.id === subjectId) {
      subject.show = !subject.show;
    }
    return subject;
  });
};

const selectedGrade = ref(props.gradeLevel);

const filteredClassesBySubject = computed(() => {
  const selectedSubjectIds = subjectDisplay.value
    .filter((subject) => subject.show)
    .map((subject) => subject.id);

  const classes = schoolStore.currentSchoolStructure?.classGroups || [];

  // Sort classes by name
  classes.sort((a: any, b: any) => {
    return a.name.localeCompare(b.name);
  });

  // Create a map to group classes by their subject IDs
  const subjectClassMap = {};

  // Populate the map with classes for each selected subject
  classes.forEach((classItem) => {
    if (
      selectedSubjectIds.includes(classItem.subject) &&
      classItem.gradeLevel === selectedGrade.value
    ) {
      if (!subjectClassMap[classItem.subject]) {
        subjectClassMap[classItem.subject] = [];
      }
      subjectClassMap[classItem.subject].push(classItem);
    }
  });

  return subjectClassMap;
});

const schoolTeachers = computed(() => {
  const teachers = schoolStore.currentSchoolStructure?.allClassGroupAdmins || [];

  // Remove any duplicate teachers
  const uniqueTeachers = unionBy(teachers, "_id");

  // Sort the teachers by their full name
  uniqueTeachers.sort((a: any, b: any) => {
    return a.firstName.localeCompare(b.firstName);
  });

  // // Return only active teachers
  // return uniqueTeachers.filter((teacher: any) => teacher.status === "active");

  return uniqueTeachers;
});

// methods
const generateUniqueUUID = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36);
};

const initialNewClassGroup = {
  name: "",
  teacher: "",
  preferredLanguage: "",
  gradeLevel: props.gradeLevel,
  subject: "",
};

const newClassGroup = ref({ ...initialNewClassGroup });

const addNewClass = (subject: SubjectDisplay) => {
  newClasses.value.push({
    tempId: generateUniqueUUID(),
    name: "",
    teacher: "",
    subject: subject.id,
    preferredLanguage: "",
    gradeLevel: props.gradeLevel,
    defaultStudentSettings: ""
  });
};

const deleteNewClass = (tempId: string) => {
  newClasses.value = newClasses.value.filter((newClass) => {
    return newClass.tempId !== tempId;
  });
};

const updateLanguageOfLearning = (classId: string, language: string) => {
  const classGroup = classesByGrade.value?.find((classGroup: ClassGroup) => {
    return classGroup._id == classId;
  });

  if (classGroup) {
    classGroup.preferredLanguage = language;
  }

  if (updatedLanguagesOfLearning.value.some((item) => item._id === classId)) {
    updatedLanguagesOfLearning.value = updatedLanguagesOfLearning.value.map(
      (item) => {
        if (item._id === classId) {
          item.preferredLanguage = language;
        }
        return item;
      }
    );
    return;
  } else {
    updatedLanguagesOfLearning.value.push({
      classGroup: classId,
      preferredLanguage: language,
    });
  }
};

const updateLockedJourneys = (classId: string, lockedJourney: string) => {
  const classGroup = classesByGrade.value?.find((classGroup: ClassGroup) => {
    return classGroup._id == classId;
  });

  if (classGroup) {
    classGroup.defaultStudentSettings = {
      "lockedJourneys" : lockedJourneySettings(lockedJourney)
    }
  }

  if (updatedDefaultStudentSettings.value.some((item) => item._id === classId)) {
    updatedDefaultStudentSettings.value = updatedDefaultStudentSettings.value.map(
      (item) => {
        if (item._id === classId) {
          item.defaultStudentSettings.lockedJourneys = lockedJourneySettings(lockedJourney)
        }
        return item;
      }
    );
    return;
  } else {
    updatedDefaultStudentSettings.value.push({
      classGroup: classId,
      defaultStudentSettings:{
        "lockedJourneys" : lockedJourneySettings(lockedJourney)
      }
    });
  }
};

const getSelectedLockedJourney = (lockedJourneys) => {
  if (!lockedJourneys || lockedJourneys.length === 0) {
    return "";
  }
  if (lockedJourneys.assessment && !lockedJourneys.catchup) {
    return "assessment";
  } else if (!lockedJourneys.assessment && lockedJourneys.catchup) {
    return "catch-up";
  } else if (!lockedJourneys.assessment && !lockedJourneys.catchup) {
    return "none";
  } else {
    return "assessment";
  }
}

const lockedJourneySettings = (lockedJourney) => {
  if (lockedJourney === "assessment") {
    return {
      assessment: true,
      catchup: false
    }
  } else if (lockedJourney === "catch-up") { 
    return {
      assessment: false,
      catchup: true
    }
  } else if (lockedJourney === "none") { 
    return {
      assessment: false,
      catchup: false
    }
  } else {
    //default settings
    return {
      assessment: true,
      catchup: false
    }
  }
}

const updateTeacherAssignment = (classId: string, teacherId: string) => {
  // check if the teacher is already assigned to the class
  const teacherAlreadyAssigned = classesByGrade.value?.find(
    (classGroup: ClassGroup) => {
      return (
        classGroup._id == classId &&
        classGroup.admins.some((admin: any) => admin._id === teacherId)
      );
    }
  );

  if (teacherAlreadyAssigned) {
    // check if the teacher is in the new teacher assignments and remove them
    const teacherAssignmentIndex = newTeacherAssignments.value.findIndex(
      (assignment) => {
        return assignment.classGroup === classId;
      }
    );

    if (teacherAssignmentIndex > -1) {
      newTeacherAssignments.value.splice(teacherAssignmentIndex, 1);
    }

    return;
  }

  // check if an assignment for the class already exists and replace it
  const existingAssignment = newTeacherAssignments.value.find((assignment) => {
    return assignment.classGroup === classId;
  });

  if (existingAssignment) {
    existingAssignment.newTeacher = teacherId;
    return;
  }

  newTeacherAssignments.value.push({
    classGroup: classId,
    newTeacher: teacherId,
    // get current teacher for class
    oldTeacher:
      classesByGrade.value?.find((classGroup: ClassGroup) => {
        return classGroup._id == classId;
      })?.admins[0]?._id ?? "",
  });
};

const markExistingClassForDeletion = (
  classId: string,
  adminId: any,
  learners: any
) => {
  console.log("Learners: ", learners);
  if (learners > 0) {
    showModalTwo.value = true;
  } else {
    // check if the class has learners
    const classHasLearners = learnerStore.getSchoolLearners.some((learner) => {
      return (
        Array.isArray(learner.classes) &&
        learner.classes.some((learnerClass) => learnerClass._id === classId)
      );
    });

    if (classHasLearners) {
      return;
    }

    // check if the class is already in the classes to delete
    const classToDeleteIndex = classesToDelete.value.findIndex(
      (classToDelete) => {
        return classToDelete.classGroup === classId;
      }
    );

    if (classToDeleteIndex > -1) {
      // classesToDelete.value.splice(classToDeleteIndex, 1);
      return;
    }

    classesToDelete.value.push({
      classGroup: classId,
      teacher: adminId,
    });
  }
};

const unmarkExistingClassForDeletion = (classId: string, adminId: any) => {
  classesToDelete.value = classesToDelete.value.filter((classToDelete) => {
    return (
      classToDelete.classGroup !== classId && classToDelete.teacher === adminId
    );
  });
};

const validateNewClasses = () => {
  // Check if any class in newClasses is missing required fields
  const invalidClass = newClasses.value.some(cls => 
    cls.name.trim() === "" || 
    // cls.teacher.trim() === "" || 
    cls.preferredLanguage.trim() === ""
  );
  if (invalidClass) {
    errorMessage.value = i18n.global.t('admin_screens.grades_and_classes_screen.validation_message');
    showModal.value = true
    throw new Error("One or more classes are missing a name or preferred language.");
  }

  //Prevent duplicate class names for each subject
  const existingClassesBySubject = Object.values(filteredClassesBySubject.value)
  .flat()
  .reduce((acc: Record<string, string[]>, classItem: any) => {
    const subject = classItem.subject;
    if (!acc[subject]) {
      acc[subject] = [];
    }
    acc[subject].push(classItem.name.trim());
    return acc;
  }, {});
  // Group new classes by subject
  const newClassesBySubject = newClasses.value.reduce(
    (acc: Record<string, string[]>, cls) => {
      const subject = cls.subject;
      if (!acc[subject]) {
        acc[subject] = [];
      }
      acc[subject].push(cls.name.trim());
      return acc;
    },
    {}
  );
  // Check for duplicates within each subject
  const allDuplicates: string[] = [];
  for (const subject in newClassesBySubject) {
    const newClassNames = newClassesBySubject[subject];
    const existingClassNames = existingClassesBySubject[subject] || [];
    // Convert names to lowercase for case-insensitive comparison
    const newClassNamesLower = newClassNames.map((name) => name.toLowerCase());
    const existingClassNamesLower = existingClassNames.map((name) =>
      name.toLowerCase()
    );
    // Find duplicates within newClasses for this subject
    const duplicatesInNewClasses = newClassNames.filter(
      (name, index) =>
        newClassNamesLower.indexOf(name.toLowerCase()) !== index
    );
    // Find duplicates between newClasses and existingClasses for this subject
    const duplicatesWithExistingClasses = newClassNames.filter((name) =>
      existingClassNamesLower.includes(name.toLowerCase())
    );
    // Combine duplicates for this subject
    allDuplicates.push(
      ...new Set([...duplicatesInNewClasses, ...duplicatesWithExistingClasses])
    );
  }
  // Format the duplicate names for the error message
  if (allDuplicates.length > 0) {
    const duplicateNamesList = allDuplicates
      .map((name) => name)
      .join(", ");

    errorMessage.value = `${i18n.global.t(
      "admin_screens.grades_and_classes_screen.duplicate_class_name_error"
    )} ${duplicateNamesList}`;

    showModal.value = true;
    throw new Error(
      `Duplicate class names detected:\n${duplicateNamesList}`
    );
  }
};

const saveProgress = async () => {
  const schoolId = schoolStore.currentSchoolStructure?._id || "";

  // Validate data
  validateNewClasses();

  // Create an object to store all the data
  const classGroupActions = {
    newClasses: [] as NewClassGroup[],
    removedClasses: [] as ClassToDelete[],
    teachersAssignment: [] as NewTeacherAssignment[],
    updatedLanguagesOfLearning: [] as any[],
    updatedDefaultStudentSettings: [] as any[]
  };

  // Collect new classes, ensuring only valid entries are included
  classGroupActions.newClasses = newClasses.value.map((localNewClass) => {
    return {
      tempId: localNewClass.tempId,
      name: localNewClass.name,
      teacher: localNewClass.teacher,
      subject: localNewClass.subject,
      gradeLevel: localNewClass.gradeLevel,
      preferredLanguage: localNewClass.preferredLanguage,
      defaultStudentSettings: {
        "lockedJourneys" : lockedJourneySettings(localNewClass.defaultStudentSettings)
      }
    };
  });

  // Collect the classes marked for deletion
  classGroupActions.removedClasses = classesToDelete.value.map(
    (classToDelete) => {
      return {
        teacher: classToDelete.teacher,
        classGroup: classToDelete.classGroup,
      };
    }
  );

  // Collect the teacher assignments
  classGroupActions.teachersAssignment = newTeacherAssignments.value.map(
    (teacherAssignment) => {
      return {
        newTeacher: teacherAssignment.newTeacher,
        oldTeacher: teacherAssignment.oldTeacher,
        classGroup: teacherAssignment.classGroup,
      };
    }
  );

  // Collect the updated languages of learning
  classGroupActions.updatedLanguagesOfLearning = updatedLanguagesOfLearning.value;

  // Collect the updated locked journeys
  classGroupActions.updatedDefaultStudentSettings = updatedDefaultStudentSettings.value;

  // Log the final object
  console.log("Saved Data:", classGroupActions);

  loading.value = true;
  try {
    let request = await schoolStore.updateSchoolDetails(
      schoolId,
      classGroupActions
    );
    console.log("Request: ", request);
    loading.value = false;
    updateSuccess.value = true;
    notifySuccessSchoolAdmin();
  } catch (error) {
    console.error(error);
  }

  newClassGroup.value = { ...initialNewClassGroup };

  newClasses.value = [];
  classesToDelete.value = [];
  updatedLanguagesOfLearning.value = [];
  newTeacherAssignments.value = [];
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.header")), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectDisplay.value, (subject) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex flex-row gap-3 items-center",
              key: subject.id
            }, [
              _withDirectives(_createElementVNode("input", {
                class: "rounded-sm",
                type: "checkbox",
                label: subject.name,
                name: subject.name,
                value: subject.show,
                onInput: ($event: any) => (updateSubjects(subject.id)),
                "onUpdate:modelValue": ($event: any) => ((subject.show) = $event),
                id: subject.name
              }, null, 40, _hoisted_4), [
                [_vModelCheckbox, subject.show]
              ]),
              _createElementVNode("label", {
                class: "text-gray-600 font-semibold text-sm",
                for: subject.name
              }, _toDisplayString(subject.name), 9, _hoisted_5)
            ]))
          }), 128))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectDisplay.value, (subject) => {
        return (_openBlock(), _createElementBlock("div", {
          key: subject.id,
          class: "mb-8"
        }, [
          (subject.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(subject.name), 1),
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("thead", _hoisted_9, [
                      _createElementVNode("tr", _hoisted_10, [
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.grade")), 1),
                        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t(
                      "admin_screens.grades_and_classes_screen.assigned_teachers"
                    )), 1),
                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.language")), 1),
                        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.locked_journeys")), 1),
                        _hoisted_15
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredClassesBySubject.value[subject.id], (classItem) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: classItem._id
                        }, [
                          _createElementVNode("td", _hoisted_16, [
                            (
                      isClassGroupMarkedForDeletion.value(
                        classItem._id,
                        classItem.admins[0]?._id
                      )
                    )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                  _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_18, [
                                    _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6 text-rl-base-pink-500" })
                                  ])), [
                                    [
                                      _directive_tooltip,
                                      _ctx.$t('admin_screens.grades_and_classes_screen.deletion_marked'),
                                      "right",
                                      { tooltip: true }
                                    ]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("p", _hoisted_20, _toDisplayString(classItem.name), 1),
                              _createElementVNode("p", _hoisted_21, _toDisplayString(getLearnerCount(
                          classItem.name,
                          subject.id || subject.id
                        )) + " " + _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.students")), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              (isClassGroupMarkedForTeacherReassignment.value(classItem._id))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                    _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_25, [
                                      _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6 text-rl-base-pink-500" })
                                    ])), [
                                      [
                                        _directive_tooltip,
                                        _ctx.$t('admin_screens.grades_and_classes_screen.new_teacher_text') + ' ' + (classItem?.admins.firstName || '') + ' ' + (classItem?.admins.lastName || ''),
                                        "right",
                                        { tooltip: true }
                                      ]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_FormKit, {
                                type: "select",
                                name: "teacher",
                                placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.select_teacher').toString(),
                                value: classItem.admins[0]?._id,
                                disabled: isClassGroupMarkedForDeletion.value(
                        classItem._id,
                        classItem.admins[0]?._id
                      )
                        ,
                                onChange: _withModifiers(($event: any) => (
                          updateTeacherAssignment(
                            classItem._id,
                            $event.target.value
                          )
                          ), ["prevent"]),
                                options: schoolTeachers.value.map((teacher) => {
                            return {
                              label: `${teacher.firstName} ${teacher.lastName}`,
                              value: teacher._id
                            }
                          }),
                                classes: {
                            outer: 'flex flex-grow',
                            wrapper: 'w-full',
                            input: 'w-full',
                          }
                              }, null, 8, ["placeholder", "value", "disabled", "onChange", "options"])
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            _createVNode(_component_FormKit, {
                              type: "select",
                              name: "language",
                              value: classItem.preferredLanguage,
                              disabled: isClassGroupMarkedForDeletion.value(
                    classItem._id,
                    classItem.admins[0]?._id
                  ),
                              options: [
                        { label: 'English ZA', value: 'en-ZA' },
                        { label: 'English GB', value: 'en-GB' },
                        { label: 'English AU', value: 'en-AU' },
                        { label: 'Swedish (Sweden) (sv-SE)', value: 'sv-SE' },
                        { label: 'Spanish (Peru) (es-PE)', value: 'es-PE' },
                        { label: 'Afrikaans', value: 'af-ZA' },
                      ],
                              onChange: _withModifiers(($event: any) => (updateLanguageOfLearning(classItem._id, $event.target.value)), ["prevent"])
                            }, null, 8, ["value", "disabled", "options", "onChange"])
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            _createVNode(_component_FormKit, {
                              type: "select",
                              name: "locked-journeys",
                              value: getSelectedLockedJourney(classItem.defaultStudentSettings?.lockedJourneys),
                              disabled: isClassGroupMarkedForDeletion.value(
                      classItem._id,
                      classItem.admins[0]?._id
                    ),
                              options: [
                      { label: 'Assessment', value: 'assessment' },
                      { label: 'Catch Up', value: 'catch-up' },
                      { label: 'None', value: 'none' },
                    ],
                              onChange: _withModifiers(($event: any) => (updateLockedJourneys(classItem._id, $event.target.value)), ["prevent"])
                            }, null, 8, ["value", "disabled", "onChange"])
                          ]),
                          _createElementVNode("td", _hoisted_28, [
                            (
                        isClassGroupMarkedForDeletion.value(
                          classItem._id,
                          classItem.admins[0]?._id
                        )
                      )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  onClick: ($event: any) => (
                      unmarkExistingClassForDeletion(
                        classItem._id,
                        classItem.admins[0]?._id
                    ))
                                }, [
                                  _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_30, [
                                    _createVNode(_unref(XMarkIcon), { class: "w-6 h-6 text-red-400" })
                                  ])), [
                                    [
                                      _directive_tooltip,
                                      _ctx.$t('admin_screens.grades_and_classes_screen.deletion_unmarked'),
                                      "left",
                                      { tooltip: true }
                                    ]
                                  ])
                                ], 8, _hoisted_29))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: ($event: any) => (
                    markExistingClassForDeletion(
                      classItem._id,
                      classItem.admins[0]?._id,
                      getLearnerCount(
                        classItem.name,
                        subject.id || subject.id
                      )
                    )
                    ),
                                  class: "w-10 h-10 disabled:opacity-30"
                                }, [
                                  _createVNode(_unref(TrashIcon), { class: "w-6 h-6 text-red-400" })
                                ], 8, _hoisted_31))
                          ])
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newClasses.value.filter(
                (newClass) =>
                  newClass.subject == subject.id &&
                  newClass.gradeLevel == props.gradeLevel
              ), (newClassGroup) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: newClassGroup.tempId
                        }, [
                          _createElementVNode("td", _hoisted_32, [
                            _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_33, [
                              _createVNode(_unref(InformationCircleIcon), { class: "w-6 h-6 text-rl-base-pink-500" })
                            ])), [
                              [
                                _directive_tooltip,
                                _ctx.$t('admin_screens.grades_and_classes_screen.new_class_added'),
                                "right",
                                { tooltip: true }
                              ]
                            ]),
                            _createVNode(_component_FormKit, {
                              type: "text",
                              name: "classCode",
                              modelValue: newClassGroup.name,
                              "onUpdate:modelValue": ($event: any) => ((newClassGroup.name) = $event),
                              placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.class_name').toString(),
                              classes: {
                    outer: 'flex flex-grow',
                    wrapper: 'w-full',
                    input: 'w-full',
                  }
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                          ]),
                          _createElementVNode("td", _hoisted_34, [
                            _createVNode(_component_FormKit, {
                              type: "select",
                              name: "teacher",
                              placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.select_teacher').toString(),
                              modelValue: newClassGroup.teacher,
                              "onUpdate:modelValue": ($event: any) => ((newClassGroup.teacher) = $event),
                              options: schoolTeachers.value.map((teacher) => {
                      return {
                        label: `${teacher.firstName} ${teacher.lastName}`,
                        value: teacher._id
                      }
                    })
                            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "options"])
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            _createVNode(_component_FormKit, {
                              type: "select",
                              name: "language",
                              placeholder: _ctx.$t('admin_screens.grades_and_classes_screen.language').toString(),
                              modelValue: newClassGroup.preferredLanguage,
                              "onUpdate:modelValue": ($event: any) => ((newClassGroup.preferredLanguage) = $event),
                              options: [
                      { label: 'English ZA', value: 'en-ZA' },
                      { label: 'English GB', value: 'en-GB' },
                      { label: 'English AU', value: 'en-AU' },
                      { label: 'Swedish (Sweden) (sv-SE)', value: 'sv-SE' },
                      { label: 'Spanish (Peru) (es-PE)', value: 'es-PE' },
                      { label: 'Afrikaans', value: 'af-ZA' },
                    ]
                            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "options"])
                          ]),
                          _createElementVNode("td", _hoisted_36, [
                            _createVNode(_component_FormKit, {
                              type: "select",
                              name: "locked-journeys",
                              modelValue: newClassGroup.defaultStudentSettings,
                              "onUpdate:modelValue": ($event: any) => ((newClassGroup.defaultStudentSettings) = $event),
                              options: [
                        { label: 'Assessment', value: 'assessment' },
                        { label: 'Catch Up', value: 'catch-up' },
                        { label: 'None', value: 'none' },
                    ]
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_37, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (deleteNewClass(newClassGroup.tempId)),
                              class: "w-10 h-10"
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "w-6 h-6 text-red-400" })
                            ], 8, _hoisted_38)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_39, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (addNewClass(subject)),
                            class: "text-sm bg-white border border-gray-300 rounded-lg font-semibold py-2.5 px-4 flex flex-row gap-1 mt-6"
                          }, [
                            _createVNode(_component_rl_icon, {
                              icon: 'rl-plus',
                              title: 'rl plus',
                              "aria-hidden": "true"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.add_class")), 1)
                          ], 8, _hoisted_40)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("button", _hoisted_43, _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.cancel")), 1),
        _createElementVNode("button", {
          onClick: saveProgress,
          class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50"
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.save_changes")), 1)
        ])
      ]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-lg px-4 py-6 rounded-lg',
        open: showModalTwo.value,
        onLocalModalOpen: _cache[0] || (_cache[0] = ($event: any) => (showModalTwo.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-red-fail',
                title: 'rl red fail',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h3", _hoisted_47, _toDisplayString(_ctx.$t(
              "admin_screens.grades_and_classes_screen.cant_do_that"
            )), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.error_text")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "button",
              class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
              onClick: closeModals
            }, _toDisplayString(_ctx.$t("admin_screens.grades_and_classes_screen.go_back")), 1)
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg px-4 py-6 rounded-lg',
      open: showModal.value,
      onLocalModalOpen: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-red-fail',
              title: 'rl red fail',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.$t('bulk_learner_upload_component.invalid_data_modal.heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("p", _hoisted_55, _toDisplayString(errorMessage.value), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})